import { render, staticRenderFns } from "./LayoutDefaultASide.vue?vue&type=template&id=553508db&"
import script from "./LayoutDefaultASide.vue?vue&type=script&lang=js&"
export * from "./LayoutDefaultASide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports